import { Box, Typography, List, ListItem } from '@mui/material'

export default function StateActionMapping({ requirements }) {
  return (
    <Box>
      {Object.entries(requirements).map(([type, data], idx) => (
        <Box key={idx} mb={2}>
          <Typography variant="h5">State: {type}</Typography>
          <Typography variant="h6">Actions:</Typography>
          <List>
            <Box
              p={3}
              border={1}
              borderColor="grey.300"
              borderRadius={2}
              mb={1}
            >
              {data.map((req, i) => (
                <ListItem key={i}>
                  {req.key} - {req.name} - {req.description}
                </ListItem>
              ))}
            </Box>
          </List>
        </Box>
      ))}
    </Box>
  )
}
